// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%238e8e8e%27><path d=%27M7 14l5-5 5 5z%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%238e8e8e%27><path d=%27M7 10l5 5 5-5z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.HolisticSearch_bw-search-container__DMMYA {
  --panel-w: 420px;
  --petal-rest-opacity: 0;
  --petal-hover-opacity: .15;
  --petal-active-opacity: .20;
  --svg-scale: .88;
  --svg-x: 0px;
  --svg-y: -4px;
  --text: #3E3E3E;
  --muted: rgba(62, 62, 62, .82);
  --line: rgba(62, 62, 62, .14);
  --t-mente: rgba(142, 167, 195, .20);
  --t-cuerpo: rgba(78, 107, 90, .20);
  --t-energia: rgba(130, 177, 148, .20);
  --t-conciencia: rgba(198, 167, 109, .20);
  width: min(1200px, 100%);
  min-height: 400px;
  margin: 0 auto 0;
  background: #F7F5F1;
  border: 1px solid rgba(12, 36, 28, 0.08);
  box-shadow: 0 18px 50px rgba(15, 23, 42, 0.08);
  border-radius: 22px;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  position: relative;
  z-index: 10;
  font-family: "Sora", sans-serif;
  margin-top: 16px;
  margin-bottom: 48px;
}
@media (max-width: 1100px) {
  .HolisticSearch_bw-search-container__DMMYA {
    height: auto;
    flex-direction: column;
    padding: 18px 0;
    margin-top: 20px;
    border-radius: 0;
    border-left: none;
    border-right: none;
  }
}
@media (max-width: 1080px) {
  .HolisticSearch_bw-search-container__DMMYA {
    margin-left: 40px;
    margin-right: 40px;
    width: auto;
  }
}
@media (max-width: 768px) {
  .HolisticSearch_bw-search-container__DMMYA {
    margin: 40px 20px 20px;
    border-radius: 26px;
    width: calc(100% - 40px);
    border: 1px solid rgba(12, 36, 28, 0.08);
  }
}
.HolisticSearch_bw-search-container__float-tip__SM-01 {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  padding: 6px 12px;
  border-radius: 10px;
  background: rgba(248, 244, 240, 0.94);
  border: 1px solid rgba(62, 62, 62, 0.2);
  color: var(--text);
  font-weight: 700;
  font-size: 13px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  transform: translate(15px, 15px);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.1s ease;
}
.HolisticSearch_bw-search-container__float-tip--visible__T3HOU {
  opacity: 1;
  visibility: visible;
}
.HolisticSearch_bw-search-container__bw-left__YhfWq {
  width: 340px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 18px 0 36px;
}
.HolisticSearch_bw-search-container__bw-left__inner__6HtWe {
  width: 100%;
  max-width: 320px;
}
@media (max-width: 768px) {
  .HolisticSearch_bw-search-container__bw-left__inner__6HtWe {
    max-width: none;
  }
}
@media (min-width: 870px) and (max-width: 1099px) {
  .HolisticSearch_bw-search-container__bw-left__inner__6HtWe {
    max-width: none;
  }
}
.HolisticSearch_bw-search-container__bw-left__title__wYUE3 {
  color: #13231d;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 0.95;
  font-size: 48px;
  margin-bottom: 14px;
}
.HolisticSearch_bw-search-container__bw-left__title__wYUE3 span {
  display: block;
  white-space: nowrap;
}
.HolisticSearch_bw-search-container__bw-left__sub__rZq31 {
  font-size: 16px;
  line-height: 1.5;
  color: rgba(19, 35, 29, 0.72);
  font-weight: 500;
}
@media (max-width: 1100px) {
  .HolisticSearch_bw-search-container__bw-left__YhfWq {
    width: 100%;
    height: auto;
    padding: 20px 24px;
    text-align: center;
  }
  .HolisticSearch_bw-search-container__bw-left__title__wYUE3 {
    font-size: 36px;
  }
  .HolisticSearch_bw-search-container__bw-left__title__wYUE3 span {
    display: inline;
    white-space: normal;
  }
}
@media (max-width: 768px) {
  .HolisticSearch_bw-search-container__bw-left__YhfWq {
    padding: 24px 20px 10px;
  }
  .HolisticSearch_bw-search-container__bw-left__title__wYUE3 {
    font-size: 32px;
  }
  .HolisticSearch_bw-search-container__bw-left__sub__rZq31 {
    font-size: 15px;
  }
}
.HolisticSearch_bw-search-container__bw-directory-link__DO3m8 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  min-height: 48px;
  margin-top: 22px;
  padding: 12px 22px;
  border: 1px solid #82B194;
  border-radius: 20px;
  background: transparent;
  color: #13231D;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 600;
  white-space: normal;
  max-width: 100%;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.18s ease, border-color 0.18s ease, color 0.18s ease;
}
@media (hover: hover) {
  .HolisticSearch_bw-search-container__bw-directory-link__DO3m8:hover {
    border-color: #739F84;
    background: rgba(130, 177, 148, 0.1);
    color: #13231D;
  }
}
.HolisticSearch_bw-search-container__bw-directory-link__DO3m8:focus-visible {
  border-color: #739F84;
  background: rgba(130, 177, 148, 0.1);
  color: #13231D;
  outline: 2px solid rgba(130, 177, 148, 0.3);
  outline-offset: 3px;
}
.HolisticSearch_bw-search-container__bw-center__El0PY {
  width: 400px;
  height: 400px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.HolisticSearch_bw-search-container__bw-center__media__R6hVK {
  width: 380px;
  height: 380px;
  object-fit: contain;
  pointer-events: auto;
  position: absolute;
  z-index: 1;
  background-color: transparent;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) {
  .HolisticSearch_bw-search-container__bw-center__media__R6hVK:not(:root) {
    background-color: transparent;
  }
}
.HolisticSearch_bw-search-container__bw-center__media__R6hVK::-webkit-media-controls-panel {
  background: transparent !important;
}
.HolisticSearch_bw-search-container__bw-center__media__R6hVK {
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  backface-visibility: hidden;
  transform: translateZ(0);
}
.HolisticSearch_bw-search-container__bw-center__media--safari-video__v--31 {
  transform: scale(1.08) translateZ(0) !important;
  -webkit-transform: scale(1.08) translateZ(0) !important;
}
@media (max-width: 768px) {
  .HolisticSearch_bw-search-container__bw-center__media--safari-video__v--31 {
    transform: scale(1.15) translateZ(0) !important;
    -webkit-transform: scale(1.15) translateZ(0) !important;
  }
}
@media (max-width: 480px) {
  .HolisticSearch_bw-search-container__bw-center__media--safari-video__v--31 {
    transform: scale(1.3) translateZ(0) !important;
    -webkit-transform: scale(1.3) translateZ(0) !important;
    margin-top: 26px;
  }
}
.HolisticSearch_bw-search-container__bw-center__svg-wrap__68A\\+7 {
  position: absolute;
  width: 380px;
  height: 380px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  pointer-events: none;
}
.HolisticSearch_bw-search-container__bw-center__svg-wrap__68A\\+7 svg {
  width: 100%;
  height: 100%;
  transform: translate(var(--svg-x), var(--svg-y)) scale(var(--svg-scale));
  transform-origin: center;
  outline: none;
  pointer-events: none;
}
@media (max-width: 1100px) {
  .HolisticSearch_bw-search-container__bw-center__El0PY {
    width: 100%;
    height: 380px;
  }
}
@media (max-width: 768px) {
  .HolisticSearch_bw-search-container__bw-center__El0PY {
    height: 320px;
  }
  .HolisticSearch_bw-search-container__bw-center__media__R6hVK, .HolisticSearch_bw-search-container__bw-center__svg-wrap__68A\\+7 {
    width: 300px;
    height: 300px;
  }
}
@media (max-width: 480px) {
  .HolisticSearch_bw-search-container__bw-center__El0PY {
    height: 280px;
  }
  .HolisticSearch_bw-search-container__bw-center__media__R6hVK, .HolisticSearch_bw-search-container__bw-center__svg-wrap__68A\\+7 {
    width: 260px;
    height: 260px;
  }
}
.HolisticSearch_bw-search-container__bw-right__-extu {
  flex: 1 1;
  height: 400px;
  padding: 18px 26px 0 10px;
}
.HolisticSearch_bw-search-container__bw-right__inner__fkU1P {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: stretch;
  padding-top: 16px;
}
@media (max-width: 1100px) {
  .HolisticSearch_bw-search-container__bw-right__-extu {
    width: 100%;
    height: auto;
    padding: 0 24px 18px;
    box-sizing: border-box;
  }
}
.HolisticSearch_bw-search-container__bw-search__tCx2p {
  position: relative;
  width: var(--panel-w);
}
.HolisticSearch_bw-search-container__bw-search__tCx2p input {
  width: 100%;
  padding: 14px 46px 14px 14px;
  box-sizing: border-box;
  border-radius: 14px;
  border: 1px solid rgba(62, 62, 62, 0.25);
  background: rgba(255, 255, 255, 0.96);
  color: var(--text);
  font-size: 16px;
  font-weight: 500;
  outline: none;
  transition: border-color 0.2s;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.HolisticSearch_bw-search-container__bw-search__tCx2p input::placeholder {
  color: rgba(19, 35, 29, 0.52);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.HolisticSearch_bw-search-container__bw-search__tCx2p input:focus {
  border-color: rgba(62, 62, 62, 0.35);
}
@media (max-width: 1100px) {
  .HolisticSearch_bw-search-container__bw-search__tCx2p {
    width: 100%;
  }
}
.HolisticSearch_bw-search-container__bw-infield-btn__fVPxh {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid rgba(62, 62, 62, 0.18);
  background: rgba(248, 244, 240, 0.96);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.HolisticSearch_bw-search-container__bw-infield-btn__fVPxh svg {
  width: 18px;
  height: 18px;
  fill: var(--text);
}
.HolisticSearch_bw-search-container__bw-stage__VEpl6 {
  width: var(--panel-w);
  position: relative;
}
.HolisticSearch_bw-search-container__bw-stage__title__LR9WF {
  font-size: 16px;
  line-height: 1.5;
  font-weight: 700;
  color: #13231d;
}
.HolisticSearch_bw-search-container__bw-stage__sub__gFN8T {
  margin-top: 5px;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 400;
  color: rgba(19, 35, 29, 0.72);
  padding-bottom: 10px;
  border-bottom: 1px solid var(--line);
}
@media (max-width: 1100px) {
  .HolisticSearch_bw-search-container__bw-stage__VEpl6 {
    width: 100%;
  }
}
.HolisticSearch_bw-search-container__bw-stage__VEpl6 {
  position: relative;
  width: var(--panel-w);
  margin-top: 2px;
  display: flex;
  align-items: flex-start;
}
.HolisticSearch_bw-search-container__bw-stage__arrow__MQydA {
  position: absolute;
  left: -28px;
  top: 2px;
  font-size: 22px;
  opacity: 0.65;
  transition: opacity 0.25s ease;
  color: #050505;
}
.HolisticSearch_bw-search-container__bw-stage__arrow--hidden__uxf9L {
  opacity: 0;
  pointer-events: none;
}
.HolisticSearch_bw-search-container__bw-stage__text__9YeSr {
  flex: 1 1;
}
.HolisticSearch_bw-search-container__bw-stage__title__LR9WF {
  font-size: 16px;
  line-height: 1.5;
  font-weight: 700;
  color: #13231d;
  min-height: 24px;
}
.HolisticSearch_bw-search-container__bw-stage__sub__gFN8T {
  margin-top: 5px;
  font-size: 16px;
  line-height: 1.4;
  font-weight: 400;
  color: rgba(19, 35, 29, 0.72);
  padding-bottom: 10px;
  border-bottom: 1px solid var(--line);
}
@media (max-width: 1100px) {
  .HolisticSearch_bw-search-container__bw-stage__VEpl6 {
    width: 100%;
  }
  .HolisticSearch_bw-search-container__bw-stage__arrow__MQydA {
    display: none;
  }
}
.HolisticSearch_bw-search-container__bw-petal__Y9exN {
  cursor: pointer;
  fill: #ffffff;
  opacity: var(--petal-rest-opacity);
  transition: opacity 0.28s cubic-bezier(0.2, 0.9, 0.2, 1);
  outline: none;
  pointer-events: auto;
}
@media (hover: hover) {
  .HolisticSearch_bw-search-container__bw-petal__Y9exN:hover {
    opacity: var(--petal-hover-opacity);
  }
}
.HolisticSearch_bw-search-container__bw-petal--active__cEBqq {
  opacity: var(--petal-active-opacity) !important;
}
.HolisticSearch_bw-search-container__bw-petal--video-playing__fLmpD {
  opacity: 0 !important;
  cursor: pointer;
}
.HolisticSearch_bw-search-container__bw-panel__BtYPr {
  height: 200px;
  width: var(--panel-w);
  position: relative;
  background: rgba(247, 245, 241, 0.72);
  backdrop-filter: blur(10px);
  border-radius: 14px;
  padding: 10px 12px 16px 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
@media (max-width: 1100px) {
  .HolisticSearch_bw-search-container__bw-panel__BtYPr {
    width: 100%;
    padding: 16px 20px 20px;
    height: 220px;
  }
}
@media (max-width: 768px) {
  .HolisticSearch_bw-search-container__bw-panel__BtYPr {
    height: auto;
    min-height: 180px;
    padding: 12px 14px 20px;
  }
}
@media (max-width: 1099px) {
  .HolisticSearch_bw-search-container__bw-panel--collapsed__ZmRxj {
    display: none;
  }
}
.HolisticSearch_bw-search-container__bw-tags__LiEM\\+ {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  flex: 1 1;
  min-height: 0;
  align-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
}
@media (max-width: 768px) {
  .HolisticSearch_bw-search-container__bw-tags__LiEM\\+ {
    max-height: 200px;
  }
}
.HolisticSearch_bw-search-container__bw-tags__LiEM\\+::-webkit-scrollbar {
  width: 20px;
}
.HolisticSearch_bw-search-container__bw-tags__LiEM\\+::-webkit-scrollbar-track {
  background: #ffffff;
}
.HolisticSearch_bw-search-container__bw-tags__LiEM\\+::-webkit-scrollbar-thumb {
  background-color: #8e8e8e;
  border-radius: 20px;
  border: 3px solid #ffffff;
}
.HolisticSearch_bw-search-container__bw-tags__LiEM\\+::-webkit-scrollbar-button {
  display: block;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-size: 8px;
  background-position: center;
  height: 14px;
}
.HolisticSearch_bw-search-container__bw-tags__LiEM\\+::-webkit-scrollbar-button:vertical:decrement {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.HolisticSearch_bw-search-container__bw-tags__LiEM\\+::-webkit-scrollbar-button:vertical:increment {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.HolisticSearch_bw-search-container__bw-tags__LiEM\\+ {
  scrollbar-color: #8e8e8e #ffffff;
}
.HolisticSearch_bw-search-container__bw-tag__UZG6Y {
  appearance: none;
  border: 1px solid rgba(62, 62, 62, 0.18);
  background: rgba(248, 244, 240, 0.94);
  border-radius: 999px;
  padding: 6px 12px;
  color: var(--text);
  cursor: pointer;
  transition: all 0.12s ease;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.25;
}
@media (hover: hover) {
  .HolisticSearch_bw-search-container__bw-tag__UZG6Y:hover {
    background: rgba(248, 244, 240, 0.98);
    border-color: rgba(62, 62, 62, 0.26);
  }
}
.HolisticSearch_bw-search-container__bw-tag--mente__53FVj {
  background: rgba(93, 138, 186, 0.12) !important;
  border-color: rgba(93, 138, 186, 0.3);
  color: #4F769F !important;
}
@media (hover: hover) {
  .HolisticSearch_bw-search-container__bw-tag--mente__53FVj:hover {
    background: rgba(93, 138, 186, 0.22) !important;
    border-color: #4F769F;
  }
}
.HolisticSearch_bw-search-container__bw-tag--cuerpo__XHU38 {
  background: rgba(36, 46, 123, 0.1) !important;
  border-color: rgba(36, 46, 123, 0.25);
  color: #242E7B !important;
}
@media (hover: hover) {
  .HolisticSearch_bw-search-container__bw-tag--cuerpo__XHU38:hover {
    background: rgba(36, 46, 123, 0.2) !important;
    border-color: #242E7B;
  }
}
.HolisticSearch_bw-search-container__bw-tag--energia__v9pip {
  background: rgba(83, 169, 110, 0.12) !important;
  border-color: rgba(83, 169, 110, 0.3);
  color: #3F8355 !important;
}
@media (hover: hover) {
  .HolisticSearch_bw-search-container__bw-tag--energia__v9pip:hover {
    background: rgba(83, 169, 110, 0.22) !important;
    border-color: #3F8355;
  }
}
.HolisticSearch_bw-search-container__bw-tag--conciencia__jWWvj {
  background: rgba(87, 64, 147, 0.1) !important;
  border-color: rgba(87, 64, 147, 0.27);
  color: #574093 !important;
}
@media (hover: hover) {
  .HolisticSearch_bw-search-container__bw-tag--conciencia__jWWvj:hover {
    background: rgba(87, 64, 147, 0.2) !important;
    border-color: #574093;
  }
}
.HolisticSearch_bw-search-container__bw-more__6f0eq {
  position: absolute;
  right: 12px;
  bottom: 10px;
  border: none;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  color: rgba(62, 62, 62, 0.92);
  background: rgba(248, 244, 240, 0.9);
  border: 1px solid rgba(62, 62, 62, 0.14);
  border-radius: 999px;
  padding: 7px 16px;
  backdrop-filter: blur(10px);
  transition: all 0.2s ease;
  font-family: "Sora", sans-serif;
  z-index: 5;
}
@media (max-width: 768px) {
  .HolisticSearch_bw-search-container__bw-more__6f0eq {
    position: relative;
    bottom: 0;
    right: 0;
    transform: none;
    width: 100%;
    margin: 12px auto 0;
    text-align: center;
    justify-content: center;
    display: flex;
    padding: 10px 20px;
  }
}
.HolisticSearch_bw-search-container__bw-more__6f0eq:active {
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/HolisticSearch/HolisticSearch.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAdA;EACI,gBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;EAEA,mCAAA;EACA,kCAAA;EACA,qCAAA;EACA,wCAAA;EAEA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBDHmB;ECInB,wCAAA;EACA,8CAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AAeJ;AAbI;EAjCJ;IAkCQ,YAAA;IACA,sBAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EAgBN;AACF;AAdI;EA3CJ;IA4CQ,iBAAA;IACA,kBAAA;IACA,WAAA;EAiBN;AACF;AAfI;EAjDJ;IAkDQ,sBAAA;IACA,mBAAA;IACA,wBAAA;IACA,wCAAA;EAkBN;AACF;AAhBI;EACI,eAAA;EACA,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eD5BY;EC6BZ,yCAAA;EACA,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,6BAAA;AAkBR;AAhBQ;EACI,UAAA;EACA,mBAAA;AAkBZ;AAdI;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAgBR;AAdQ;EACI,WAAA;EACA,gBAAA;AAgBZ;AAdY;EAJJ;IAKQ,eAAA;EAiBd;AACF;AAfY;EARJ;IASQ,eAAA;EAkBd;AACF;AAfQ;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AAiBZ;AAfY;EACI,cAAA;EACA,mBAAA;AAiBhB;AAbQ;EACI,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;AAeZ;AAZQ;EA1CJ;IA2CQ,WAAA;IACA,YAAA;IACA,kBAAA;IACA,kBAAA;EAeV;EAbU;IACI,eAAA;EAed;EAbc;IACI,eAAA;IACA,mBAAA;EAelB;AACF;AAXQ;EA1DJ;IA2DQ,uBAAA;EAcV;EAZU;IACI,eAAA;EAcd;EAXU;IACI,eAAA;EAad;AACF;AATI;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,kFAAA;AAWR;AATQ;EACI;IACI,qBAAA;IACA,oCAAA;IACA,cAAA;EAWd;AACF;AARQ;EACI,qBAAA;EACA,oCAAA;EACA,cAAA;EACA,2CAAA;EACA,mBAAA;AAUZ;AANI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAQR;AANQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;AAQZ;AANY;EACI;IACI,6BAAA;EAQlB;AACF;AALY;EACI,kCAAA;AAOhB;AAvBQ;EAmBI,mCAAA;EACA,gCAAA;EACA,2BAAA;EACA,wBAAA;AAOZ;AALY;EACI,+CAAA;EACA,uDAAA;AAOhB;AALgB;EAJJ;IAKQ,+CAAA;IACA,uDAAA;EAQlB;AACF;AAPgB;EARJ;IASQ,8CAAA;IACA,sDAAA;IACA,gBAAA;EAUlB;AACF;AANQ;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;AAQZ;AAJY;EACI,WAAA;EACA,YAAA;EACA,wEAAA;EACA,wBAAA;EACA,aAAA;EACA,oBAAA;AAMhB;AAFQ;EAtEJ;IAuEQ,WAAA;IACA,aAAA;EAKV;AACF;AAHQ;EA3EJ;IA4EQ,aAAA;EAMV;EAJU;IACI,YAAA;IACA,aAAA;EAMd;AACF;AAHQ;EApFJ;IAqFQ,aAAA;EAMV;EAJU;IACI,YAAA;IACA,aAAA;EAMd;AACF;AADI;EACI,SAAA;EACA,aAAA;EACA,yBAAA;AAGR;AADQ;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;EACA,iBAAA;AAGZ;AAAQ;EAdJ;IAeQ,WAAA;IACA,YAAA;IACA,oBAAA;IACA,sBAAA;EAGV;AACF;AAAI;EACI,kBAAA;EACA,qBAAA;AAER;AAAQ;EACI,WAAA;EACA,4BAAA;EACA,sBAAA;EACA,mBAAA;EACA,wCAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEZ;AAAY;EACI,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAEhB;AACY;EACI,oCAAA;AAChB;AAGQ;EAhCJ;IAiCQ,WAAA;EAAV;AACF;AAEI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAAR;AAGI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AADR;AAII;EACI,qBAAA;EACA,kBAAA;AAFR;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAFZ;AAKQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,oBAAA;EACA,oCAAA;AAHZ;AAMQ;EArBJ;IAsBQ,WAAA;EAHV;AACF;AAMI;EACI,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;AAJR;AAMQ;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,cAAA;AAJZ;AAMY;EACI,UAAA;EACA,oBAAA;AAJhB;AAQQ;EACI,SAAA;AANZ;AASQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAPZ;AAUQ;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,oBAAA;EACA,oCAAA;AARZ;AAWQ;EA5CJ;IA6CQ,WAAA;EARV;EAUU;IACI,aAAA;EARd;AACF;AAaI;EACI,eAAA;EACA,aAAA;EACA,kCAAA;EACA,wDAAA;EACA,aAAA;EACA,oBAAA;AAXR;AAaQ;EACI;IACI,mCAAA;EAXd;AACF;AAcQ;EACI,+CAAA;AAZZ;AAeQ;EACI,qBAAA;EACA,eAAA;AAbZ;AAkBI;EACI,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,4BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAhBR;AAkBQ;EAZJ;IAaQ,WAAA;IACA,uBAAA;IACA,aAAA;EAfV;AACF;AAiBQ;EAlBJ;IAmBQ,YAAA;IACA,iBAAA;IACA,uBAAA;EAdV;AACF;AAiBY;EADJ;IAEQ,aAAA;EAdd;AACF;AAkBI;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AAhBR;AAkBQ;EAXJ;IAYQ,iBAAA;EAfV;AACF;AAiBQ;EACI,WAAA;AAfZ;AAkBQ;EACI,mBAAA;AAhBZ;AAkBQ;EACI,yBAAA;EACA,mBAAA;EACA,yBAAA;AAhBZ;AAmBQ;EACI,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,oBAAA;EACA,2BAAA;EACA,YAAA;AAjBZ;AAoBQ;EACI,yDAAA;AAlBZ;AAqBQ;EACI,yDAAA;AAnBZ;AAvBI;EA6CI,gCAAA;AAnBR;AAsBI;EACI,gBAAA;EACA,wCAAA;EACA,qCAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AApBR;AAsBQ;EACI;IACI,qCAAA;IACA,oCAAA;EApBd;AACF;AAuBQ;EACI,+CAAA;EAA6C,qCAAA;EAAoC,yBAAA;AAnB7F;AAoBY;EAAwB;IAAU,+CAAA;IAA6C,qBAAA;EAfzF;AACF;AAiBQ;EACI,6CAAA;EAA4C,qCAAA;EAAmC,yBAAA;AAb3F;AAcY;EAAwB;IAAU,6CAAA;IAA4C,qBAAA;EATxF;AACF;AAWQ;EACI,+CAAA;EAA6C,qCAAA;EAAoC,yBAAA;AAP7F;AAQY;EAAwB;IAAU,+CAAA;IAA6C,qBAAA;EAHzF;AACF;AAKQ;EACI,6CAAA;EAA4C,qCAAA;EAAmC,yBAAA;AAD3F;AAEY;EAAwB;IAAU,6CAAA;IAA4C,qBAAA;EAGxF;AACF;AAAI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,oCAAA;EACA,wCAAA;EACA,oBAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;EACA,+BAAA;EACA,UAAA;AAER;AAAQ;EAlBJ;IAmBQ,kBAAA;IACA,SAAA;IACA,QAAA;IACA,eAAA;IACA,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,uBAAA;IACA,aAAA;IACA,kBAAA;EAGV;AACF;AACQ;EACI,wBAAA;AACZ","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n.bw-search-container {\n    --panel-w: 420px;\n    --petal-rest-opacity: 0;\n    --petal-hover-opacity: .15;\n    --petal-active-opacity: .20;\n    --svg-scale: .88;\n    --svg-x: 0px;\n    --svg-y: -4px;\n    --text: #3E3E3E;\n    --muted: rgba(62, 62, 62, .82);\n    --line: rgba(62, 62, 62, .14);\n\n    --t-mente: rgba(142, 167, 195, .20);\n    --t-cuerpo: rgba(78, 107, 90, .20);\n    --t-energia: rgba(130, 177, 148, .20);\n    --t-conciencia: rgba(198, 167, 109, .20);\n\n    width: min(1200px, 100%);\n    min-height: 400px;\n    margin: 0 auto 0; \n    background: $color-surface;\n    border: 1px solid rgba(12, 36, 28, .08);\n    box-shadow: 0 18px 50px rgba(15, 23, 42, .08);\n    border-radius: 22px;\n    overflow: hidden;\n    display: flex;\n    align-items: flex-start;\n    position: relative;\n    z-index: 10;\n    font-family: 'Sora', sans-serif;\n    margin-top: 16px;\n    margin-bottom: 48px;\n\n    @media (max-width: 1100px) {\n        height: auto;\n        flex-direction: column;\n        padding: 18px 0;\n        margin-top: 20px;\n        border-radius: 0;\n        border-left: none;\n        border-right: none;\n    }\n\n    @media (max-width: 1080px) {\n        margin-left: 40px;\n        margin-right: 40px;\n        width: auto;\n    }\n\n    @media (max-width: 768px) {\n        margin: 40px 20px 20px;\n        border-radius: 26px;\n        width: calc(100% - 40px);\n        border: 1px solid rgba(12, 36, 28, .08);\n    }\n\n    &__float-tip {\n        position: fixed;\n        z-index: 9999;\n        pointer-events: none;\n        padding: 6px 12px;\n        border-radius: 10px;\n        background: rgba(248, 244, 240, .94);\n        border: 1px solid rgba(62, 62, 62, .20);\n        color: var(--text);\n        font-weight: 700;\n        font-size: $font-size-caption;\n        box-shadow: 0 8px 20px rgba(0, 0, 0, .10);\n        transform: translate(15px, 15px); \n        opacity: 0;\n        visibility: hidden;\n        transition: opacity .1s ease;\n\n        &--visible {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n\n    &__bw-left {\n        width: 340px;\n        height: 400px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 0 18px 0 36px;\n\n        &__inner {\n            width: 100%;\n            max-width: 320px;\n\n            @media (max-width: 768px) {\n                max-width: none;\n            }\n\n            @media (min-width: 870px) and (max-width: 1099px) {\n                max-width: none;\n            }\n        }\n\n        &__title {\n            color: #13231d;\n            font-weight: 800;\n            letter-spacing: -0.03em;\n            line-height: 0.95;\n            font-size: 48px;\n            margin-bottom: 14px;\n\n            span {\n                display: block;\n                white-space: nowrap;\n            }\n        }\n\n        &__sub {\n            font-size: 16px;\n            line-height: 1.5;\n            color: rgba(19, 35, 29, .72);\n            font-weight: 500;\n        }\n\n        @media (max-width: 1100px) {\n            width: 100%;\n            height: auto;\n            padding: 20px 24px;\n            text-align: center;\n\n            &__title {\n                font-size: 36px;\n                \n                span {\n                    display: inline;\n                    white-space: normal;\n                }\n            }\n        }\n\n        @media (max-width: 768px) {\n            padding: 24px 20px 10px;\n            \n            &__title {\n                font-size: 32px;\n            }\n\n            &__sub {\n                font-size: 15px;\n            }\n        }\n    }\n\n    &__bw-directory-link {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        align-self: flex-start;\n        min-height: 48px;\n        margin-top: 22px;\n        padding: 12px 22px;\n        border: 1px solid #82B194;\n        border-radius: 20px;\n        background: transparent;\n        color: #13231D;\n        font-size: 14px;\n        line-height: 1.35;\n        font-weight: 600;\n        white-space: normal;\n        max-width: 100%;\n        text-align: center;\n        text-decoration: none;\n        transition: background-color .18s ease, border-color .18s ease, color .18s ease;\n\n        @media (hover: hover) {\n            &:hover {\n                border-color: #739F84;\n                background: rgba(130,177,148,.10);\n                color: #13231D;\n            }\n        }\n\n        &:focus-visible {\n            border-color: #739F84;\n            background: rgba(130,177,148,.10);\n            color: #13231D;\n            outline: 2px solid rgba(130,177,148,.30);\n            outline-offset: 3px;\n        }\n    }\n\n    &__bw-center {\n        width: 400px;\n        height: 400px;\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &__media {\n            width: 380px;\n            height: 380px;\n            object-fit: contain;\n            pointer-events: auto;\n            position: absolute;\n            z-index: 1;\n            background-color: transparent;\n            \n            @media screen and (-webkit-min-device-pixel-ratio: 0) {\n                &:not(:root) {\n                    background-color: transparent;\n                }\n            }\n            \n            &::-webkit-media-controls-panel {\n                background: transparent !important;\n            }\n\n            -webkit-backface-visibility: hidden;\n            -webkit-transform: translateZ(0);\n            backface-visibility: hidden;\n            transform: translateZ(0);\n\n            &--safari-video {\n                transform: scale(1.08) translateZ(0) !important;\n                -webkit-transform: scale(1.08) translateZ(0) !important;\n\n                @media (max-width: 768px) {\n                    transform: scale(1.15) translateZ(0) !important;\n                    -webkit-transform: scale(1.15) translateZ(0) !important;\n                }\n                @media (max-width: 480px) {\n                    transform: scale(1.30) translateZ(0) !important;\n                    -webkit-transform: scale(1.30) translateZ(0) !important;\n                    margin-top: 26px;\n                }\n            }\n        }\n\n        &__svg-wrap {\n            position: absolute;\n            width: 380px;\n            height: 380px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            z-index: 2;\n            pointer-events: none;\n\n\n\n            svg {\n                width: 100%;\n                height: 100%;\n                transform: translate(var(--svg-x), var(--svg-y)) scale(var(--svg-scale));\n                transform-origin: center;\n                outline: none;\n                pointer-events: none;\n            }\n        }\n\n        @media (max-width: 1100px) {\n            width: 100%;\n            height: 380px;\n        }\n\n        @media (max-width: 768px) {\n            height: 320px;\n\n            &__media, &__svg-wrap {\n                width: 300px;\n                height: 300px;\n            }\n        }\n\n        @media (max-width: 480px) {\n            height: 280px;\n\n            &__media, &__svg-wrap {\n                width: 260px;\n                height: 260px;\n            }\n        }\n    }\n\n\n    &__bw-right {\n        flex: 1;\n        height: 400px;\n        padding: 18px 26px 0 10px;\n\n        &__inner {\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n            gap: 10px;\n            align-items: stretch;\n            padding-top: 16px;\n        }\n\n        @media (max-width: 1100px) {\n            width: 100%;\n            height: auto;\n            padding: 0 24px 18px;\n            box-sizing: border-box;\n        }\n    }\n\n    &__bw-search {\n        position: relative;\n        width: var(--panel-w);\n\n        input {\n            width: 100%;\n            padding: 14px 46px 14px 14px;\n            box-sizing: border-box;\n            border-radius: 14px;\n            border: 1px solid rgba(62, 62, 62, .25);\n            background: rgba(255, 255, 255, .96);\n            color: var(--text);\n            font-size: 16px;\n            font-weight: 500;\n            outline: none;\n            transition: border-color .2s;\n            white-space: nowrap;\n            overflow: hidden;\n            text-overflow: ellipsis;\n\n            &::placeholder {\n                color: rgba(19, 35, 29, .52);\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n\n            &:focus {\n                border-color: rgba(62, 62, 62, .35);\n            }\n        }\n\n        @media (max-width: 1100px) {\n            width: 100%;\n        }\n    }\n    &__bw-infield-btn {\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 34px;\n        height: 34px;\n        border-radius: 10px;\n        border: 1px solid rgba(62, 62, 62, .18);\n        background: rgba(248, 244, 240, .96);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n    }\n\n    &__bw-infield-btn svg {\n        width: 18px;\n        height: 18px;\n        fill: var(--text);\n    }\n\n    &__bw-stage {\n        width: var(--panel-w);\n        position: relative;\n\n        &__title {\n            font-size: 16px;\n            line-height: 1.5;\n            font-weight: 700;\n            color: #13231d;\n        }\n\n        &__sub {\n            margin-top: 5px;\n            font-size: 16px;\n            line-height: 1.5;\n            font-weight: 400;\n            color: rgba(19, 35, 29, .72);\n            padding-bottom: 10px;\n            border-bottom: 1px solid var(--line);\n        }\n\n        @media (max-width: 1100px) {\n            width: 100%;\n        }\n    }\n\n    &__bw-stage {\n        position: relative;\n        width: var(--panel-w);\n        margin-top: 2px;\n        display: flex;\n        align-items: flex-start;\n\n        &__arrow {\n            position: absolute;\n            left: -28px;\n            top: 2px;\n            font-size: 22px;\n            opacity: .65;\n            transition: opacity 0.25s ease;\n            color: #050505;\n\n            &--hidden {\n                opacity: 0;\n                pointer-events: none;\n            }\n        }\n\n        &__text {\n            flex: 1;\n        }\n\n        &__title {\n            font-size: 16px;\n            line-height: 1.5;\n            font-weight: 700;\n            color: #13231d;\n            min-height: 24px;\n        }\n\n        &__sub {\n            margin-top: 5px;\n            font-size: 16px;\n            line-height: 1.4;\n            font-weight: 400;\n            color: rgba(19, 35, 29, .72);\n            padding-bottom: 10px;\n            border-bottom: 1px solid var(--line);\n        }\n\n        @media (max-width: 1100px) {\n            width: 100%;\n\n            &__arrow {\n                display: none;\n            }\n        }\n    }\n\n\n    &__bw-petal {\n        cursor: pointer;\n        fill: #ffffff;\n        opacity: var(--petal-rest-opacity);\n        transition: opacity .28s cubic-bezier(.2, .9, .2, 1);\n        outline: none;\n        pointer-events: auto;\n\n        @media (hover: hover) {\n            &:hover {\n                opacity: var(--petal-hover-opacity);\n            }\n        }\n\n        &--active {\n            opacity: var(--petal-active-opacity) !important;\n        }\n\n        &--video-playing {\n            opacity: 0 !important;\n            cursor: pointer;\n        }\n    }\n\n\n    &__bw-panel {\n        height: 200px;\n        width: var(--panel-w);\n        position: relative;\n        background: rgba($color-surface, .72);\n        backdrop-filter: blur(10px);\n        border-radius: 14px;\n        padding: 10px 12px 16px 12px;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n\n        @media (max-width: 1100px) {\n            width: 100%;\n            padding: 16px 20px 20px;\n            height: 220px;\n        }\n        \n        @media (max-width: 768px) {\n            height: auto;\n            min-height: 180px;\n            padding: 12px 14px 20px;\n        }\n\n        &--collapsed {\n            @media (max-width: 1099px) {\n                display: none;\n            }\n        }\n    }\n\n    &__bw-tags {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 4px;\n        flex: 1;\n        min-height: 0;\n        align-content: flex-start;\n        overflow-y: auto;\n        overflow-x: hidden;\n        padding-right: 10px; \n\n        @media (max-width: 768px) {\n            max-height: 200px;\n        }\n\n        &::-webkit-scrollbar {\n            width: 20px; \n        }\n\n        &::-webkit-scrollbar-track {\n            background: #ffffff; \n        }\n        &::-webkit-scrollbar-thumb {\n            background-color: #8e8e8e; \n            border-radius: 20px; \n            border: 3px solid #ffffff;\n        }\n\n        &::-webkit-scrollbar-button {\n            display: block;\n            background-color: #ffffff;\n            background-repeat: no-repeat;\n            background-size: 8px;\n            background-position: center;\n            height: 14px;\n        }\n\n        &::-webkit-scrollbar-button:vertical:decrement {\n            background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%238e8e8e'><path d='M7 14l5-5 5 5z'/></svg>\");\n        }\n\n        &::-webkit-scrollbar-button:vertical:increment {\n            background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%238e8e8e'><path d='M7 10l5 5 5-5z'/></svg>\");\n        }\n\n        scrollbar-color: #8e8e8e #ffffff;\n    }\n\n    &__bw-tag {\n        appearance: none;\n        border: 1px solid rgba(62, 62, 62, .18);\n        background: rgba(248, 244, 240, .94);\n        border-radius: 999px;\n        padding: 6px 12px;\n        color: var(--text);\n        cursor: pointer;\n        transition: all .12s ease;\n        white-space: nowrap;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 1.25;\n\n        @media (hover: hover) {\n            &:hover {\n                background: rgba(248, 244, 240, .98);\n                border-color: rgba(62, 62, 62, .26);\n            }\n        }\n\n        &--mente {\n            background: rgba(93,138,186,.12) !important; border-color: rgba(93,138,186,.30); color: #4F769F !important;\n            @media (hover: hover) { &:hover { background: rgba(93,138,186,.22) !important; border-color: #4F769F; } }\n        }\n\n        &--cuerpo {\n            background: rgba(36,46,123,.10) !important; border-color: rgba(36,46,123,.25); color: #242E7B !important;\n            @media (hover: hover) { &:hover { background: rgba(36,46,123,.20) !important; border-color: #242E7B; } }\n        }\n\n        &--energia {\n            background: rgba(83,169,110,.12) !important; border-color: rgba(83,169,110,.30); color: #3F8355 !important;\n            @media (hover: hover) { &:hover { background: rgba(83,169,110,.22) !important; border-color: #3F8355; } }\n        }\n\n        &--conciencia {\n            background: rgba(87,64,147,.10) !important; border-color: rgba(87,64,147,.27); color: #574093 !important;\n            @media (hover: hover) { &:hover { background: rgba(87,64,147,.20) !important; border-color: #574093; } }\n        }\n    }\n\n    &__bw-more {\n        position: absolute;\n        right: 12px;\n        bottom: 10px;\n        border: none;\n        cursor: pointer;\n        font-weight: 600; \n        font-size: 14px;\n        color: rgba(62, 62, 62, .92);\n        background: rgba(248, 244, 240, .90);\n        border: 1px solid rgba(62, 62, 62, .14);\n        border-radius: 999px;\n        padding: 7px 16px;\n        backdrop-filter: blur(10px);\n        transition: all 0.2s ease;\n        font-family: 'Sora', sans-serif;\n        z-index: 5;\n\n        @media (max-width: 768px) {\n            position: relative;\n            bottom: 0;\n            right: 0;\n            transform: none;\n            width: 100%;\n            margin: 12px auto 0;\n            text-align: center;\n            justify-content: center;\n            display: flex;\n            padding: 10px 20px;\n        }\n\n       \n\n        &:active {\n            transform: translateY(0);\n        }\n    }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bw-search-container": `HolisticSearch_bw-search-container__DMMYA`,
	"bw-search-container__float-tip": `HolisticSearch_bw-search-container__float-tip__SM-01`,
	"bw-search-container__float-tip--visible": `HolisticSearch_bw-search-container__float-tip--visible__T3HOU`,
	"bw-search-container__bw-left": `HolisticSearch_bw-search-container__bw-left__YhfWq`,
	"bw-search-container__bw-left__inner": `HolisticSearch_bw-search-container__bw-left__inner__6HtWe`,
	"bw-search-container__bw-left__title": `HolisticSearch_bw-search-container__bw-left__title__wYUE3`,
	"bw-search-container__bw-left__sub": `HolisticSearch_bw-search-container__bw-left__sub__rZq31`,
	"bw-search-container__bw-directory-link": `HolisticSearch_bw-search-container__bw-directory-link__DO3m8`,
	"bw-search-container__bw-center": `HolisticSearch_bw-search-container__bw-center__El0PY`,
	"bw-search-container__bw-center__media": `HolisticSearch_bw-search-container__bw-center__media__R6hVK`,
	"bw-search-container__bw-center__media--safari-video": `HolisticSearch_bw-search-container__bw-center__media--safari-video__v--31`,
	"bw-search-container__bw-center__svg-wrap": `HolisticSearch_bw-search-container__bw-center__svg-wrap__68A+7`,
	"bw-search-container__bw-right": `HolisticSearch_bw-search-container__bw-right__-extu`,
	"bw-search-container__bw-right__inner": `HolisticSearch_bw-search-container__bw-right__inner__fkU1P`,
	"bw-search-container__bw-search": `HolisticSearch_bw-search-container__bw-search__tCx2p`,
	"bw-search-container__bw-infield-btn": `HolisticSearch_bw-search-container__bw-infield-btn__fVPxh`,
	"bw-search-container__bw-stage": `HolisticSearch_bw-search-container__bw-stage__VEpl6`,
	"bw-search-container__bw-stage__title": `HolisticSearch_bw-search-container__bw-stage__title__LR9WF`,
	"bw-search-container__bw-stage__sub": `HolisticSearch_bw-search-container__bw-stage__sub__gFN8T`,
	"bw-search-container__bw-stage__arrow": `HolisticSearch_bw-search-container__bw-stage__arrow__MQydA`,
	"bw-search-container__bw-stage__arrow--hidden": `HolisticSearch_bw-search-container__bw-stage__arrow--hidden__uxf9L`,
	"bw-search-container__bw-stage__text": `HolisticSearch_bw-search-container__bw-stage__text__9YeSr`,
	"bw-search-container__bw-petal": `HolisticSearch_bw-search-container__bw-petal__Y9exN`,
	"bw-search-container__bw-petal--active": `HolisticSearch_bw-search-container__bw-petal--active__cEBqq`,
	"bw-search-container__bw-petal--video-playing": `HolisticSearch_bw-search-container__bw-petal--video-playing__fLmpD`,
	"bw-search-container__bw-panel": `HolisticSearch_bw-search-container__bw-panel__BtYPr`,
	"bw-search-container__bw-panel--collapsed": `HolisticSearch_bw-search-container__bw-panel--collapsed__ZmRxj`,
	"bw-search-container__bw-tags": `HolisticSearch_bw-search-container__bw-tags__LiEM+`,
	"bw-search-container__bw-tag": `HolisticSearch_bw-search-container__bw-tag__UZG6Y`,
	"bw-search-container__bw-tag--mente": `HolisticSearch_bw-search-container__bw-tag--mente__53FVj`,
	"bw-search-container__bw-tag--cuerpo": `HolisticSearch_bw-search-container__bw-tag--cuerpo__XHU38`,
	"bw-search-container__bw-tag--energia": `HolisticSearch_bw-search-container__bw-tag--energia__v9pip`,
	"bw-search-container__bw-tag--conciencia": `HolisticSearch_bw-search-container__bw-tag--conciencia__jWWvj`,
	"bw-search-container__bw-more": `HolisticSearch_bw-search-container__bw-more__6f0eq`
};
export default ___CSS_LOADER_EXPORT___;
